export const sexOptions = [
    { value: 'UNKNOWN', label: 'Não indicado' },
    { value: 'FEMALE', label: 'Feminino' },
    { value: 'MALE', label: 'Masculino' },
    { value: 'NB_INTERSEX', label: 'Não binário / intersexo' }
];

export const genderOptions = [
    { value: 'UNKNOWN', label: 'Não indicado' },
    { value: 'WOMAN', label: 'Mulher' },
    { value: 'MAN', label: 'Homem' },
    { value: 'TRANS_WOMAN', label: 'Mulher trans' },
    { value: 'TRANS_MAN', label: 'Homem trans' },
    { value: 'NONBINARY', label: 'Não binário' },
    { value: 'AGENDER', label: 'Agénero' },
    { value: 'GENDERQUEER', label: 'Genderqueer' },
    { value: 'PREFER_NO_ANSWER', label: 'Prefiro não responder' },
    { value: 'NOT_LISTED', label: 'Outra identidade' }
];

export const localeOptions = [
    { value: 'pt_PT', label: 'Português (Portugal)' },
    { value: 'en_GB', label: 'English (United Kingdom)' },
    { value: 'en_US', label: 'English (United States)' },
    { value: 'pt_BR', label: 'Português (Brasil)' }
];

const countryCodes =
    'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(
        ' '
    );
export const getCountryOptions = (language = 'pt') => {
    const locale = language === 'en' ? 'en-GB' : 'pt-PT';
    const names =
        typeof Intl.DisplayNames === 'function'
            ? new Intl.DisplayNames([locale], { type: 'region' })
            : null;
    return countryCodes
        .map((value) => ({
            value,
            label: names?.of(value) || value
        }))
        .sort((a, b) => a.label.localeCompare(b.label, locale));
};
export const countryOptions = getCountryOptions();

export const getTimezoneOptions = (current) =>
    [
        ...new Set([
            'UTC',
            'Europe/Lisbon',
            ...(current ? [current] : []),
            ...(typeof Intl.supportedValuesOf === 'function'
                ? Intl.supportedValuesOf('timeZone')
                : [])
        ])
    ].sort();

export const roleLabels = {
    PATIENT: 'Paciente',
    DOCTOR: 'Médico',
    CLINIC_CARE_GIVER: 'Técnico de saúde',
    PATIENT_CARE_GIVER: 'Cuidador'
};
